import React from 'react';

/**
 * Thin progress bar. Track is --border-subtle, fill defaults to --accent.
 * Pass color="var(--success)" when value >= 95 to signal completion.
 *
 *   value   0–100 (clamped)
 *   height  px; default 4
 *   color   any CSS color string; default --accent
 */
export default function Progress({ value = 0, height = 4, color = 'var(--accent)' }) {
  const clamped = Math.max(0, Math.min(100, value));
  // Floor of 1.5% so a tiny value still shows a visible nub rather than
  // disappearing into the track.
  const visibleWidth = clamped > 0 ? Math.max(clamped, 1.5) : 0;
  return (
    <div
      style={{
        position: 'relative',
        height,
        background: 'var(--border-subtle)',
        borderRadius: 999,
        overflow: 'hidden',
      }}
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          width: `${visibleWidth}%`,
          background: color,
          borderRadius: 999,
          transition: 'width .25s ease-out',
        }}
      />
    </div>
  );
}
